module.exports = __webpack_public_path__ + "static/media/Aviso de Privacidad PTM ES.7776101c.pdf";